(() => {
  const init = (root) => {
    const choices = [...root.querySelectorAll('[data-size-choice]')];
    const products = [...root.querySelectorAll('[data-size-product]')];
    choices.forEach((choice) => {
      choice.addEventListener('click', () => {
        const size = choice.dataset.sizeChoice;
        choices.forEach((item) => {
          const active = item === choice;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        products.forEach((product) => product.classList.toggle('is-selected', product.dataset.sizeProduct === size));
      });
    });

    const openButton = root.querySelector('[data-nh4-consult-open]');
    const dialog = root.querySelector('[data-nh4-consult-dialog]');
    if (openButton && dialog && dialog.dataset.nh4Bound !== 'true') {
      dialog.dataset.nh4Bound = 'true';

      openButton.addEventListener('click', () => {
        if (!dialog.open) dialog.showModal();
      });

      dialog.querySelectorAll('[data-nh4-consult-close]').forEach((button) => {
        button.addEventListener('click', () => dialog.close());
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      dialog.addEventListener('close', () => openButton.focus());
    }
  };

  document.querySelectorAll('[data-nh4]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-nh4]').forEach(init);
  });
})();
